export default __webpack_public_path__ + "a17518dc4446cc96ff920faebdc0c4b8.png";